// Where front end connect to the back end

// This file contains all the API calls that the front end makes to the back end
import { getInstance } from "../auth/index.js";
import { serverUrl } from '../auth/auth_config.json';
import axios from "axios";
import { silentURLUpdate } from "./Utils";


export async function filterAudits(searchTerms) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    // Encode each search term and join them with a separator (e.g., a comma)
    //const query = searchTerms.map((term) => encodeURIComponent(term)).join(',');
    //const query = convertParamsToQueryString(searchTerms);

    const endpoint = process.env.VUE_APP_API_AUDIT_SEARCH + '?query=' + searchTerms;
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });

    return response.data;
  } catch (error) {
    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function advancedFilterAudits(searchObject) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const response = await axios.post(process.env.VUE_APP_API_AUDIT_ADVANCED_SEARCH, {
      query: searchObject
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error; // re-throw the error so it can be caught by the caller
  }
}


export async function getAudits() {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_AUDITS;
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data;
  } catch (error) {

    throw error; // re-throw the error so it can be caught by the caller
  }
}


export async function getRelatedNotices(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_RELATED_NOTICES + "/" + id;
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data.data;
  } catch (error) {

    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function getDataLineage(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_DATA_LINEAGE + "/" + id;
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data.data;
  } catch (error) {

    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function getCurrentUserProfile() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const response = await axios.get(process.env.VUE_APP_API_USER, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    //////console.error(error);
    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function fetchIndustries() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_INDUSTRIES
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function fetchIndustriesList() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_INDUSTRIES_LIST
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN FETCH INDUSTRIES LIST.. ERROR: ", error );
      return error;
    });
}

export async function fetchTags(searchTerm = '', industryId = null) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_TAGS;
  
  // Build query parameters
  const params = {};
  if (searchTerm && searchTerm.trim()) {
    params.term = searchTerm.trim();
  }
  if (industryId) {
    // Industry ID can be string or number, convert to string to match backend
    params.industry_id = String(industryId);
  }

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN FETCH TAGS.. ERROR: ", error );
      return error;
    });
}

export async function getHistory() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    var endpoint = process.env.VUE_APP_API_USER_LOG;
    //var data = {cluster_ids: clusterIds, entity_type: entityType, entities: entities}

    return axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      });

  } catch (error) {
    //////console.error(error);
    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function userLog(fullPath) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    var endpoint = process.env.VUE_APP_API_USER_LOG;
    //var data = {cluster_ids: clusterIds, entity_type: entityType, entities: entities}

    return axios
      .post(endpoint, { route: fullPath }, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => {
        ////////////////////////console.log(response.data);
        return response.data;
      })
      .catch(error => {
        return error;
      });

  } catch (error) {
    //////console.error(error);
    throw error; // re-throw the error so it can be caught by the caller
  }
}


export async function getSupplier(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_GET_SUPPLIER + '?id=' + id;
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data;
  } catch (error) {

    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function searchSuppliers(searchText, page = 1, pageSize = 50, filters = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    let endpoint = process.env.VUE_APP_API_SUPPLIER_SEARCH + '?search=' + searchText + '&page=' + page + '&page_size=' + pageSize;
    
    // Add filter parameters if provided
    if (filters.industry_id && filters.industry_id.length > 0) {
      const industryIds = Array.isArray(filters.industry_id) ? filters.industry_id : [filters.industry_id];
      endpoint += '&industry_id=' + industryIds.join(',');
    }
    
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data;
  } catch (error) {

    throw error; // re-throw the error so it can be caught by the caller
  }
}

export async function searchBuyers(searchText, page = 1, pageSize = 50, filters = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    let endpoint = process.env.VUE_APP_API_BUYER_SEARCH + '?search=' + searchText + '&page=' + page + '&page_size=' + pageSize;
    
    // Add filter parameters if provided
    if (filters.gov_type && filters.gov_type.length > 0) {
      const govTypes = Array.isArray(filters.gov_type) ? filters.gov_type : [filters.gov_type];
      endpoint += '&gov_type=' + govTypes.join(',');
    }
    
    if (filters.cofog_code && filters.cofog_code.length > 0) {
      const cofogCodes = Array.isArray(filters.cofog_code) ? filters.cofog_code : [filters.cofog_code];
      endpoint += '&cofog_code=' + cofogCodes.join(',');
    }
    
    // Keep publisher_industry support for backward compatibility
    if (filters.publisher_industry && filters.publisher_industry.length > 0) {
      const industries = Array.isArray(filters.publisher_industry) ? filters.publisher_industry : [filters.publisher_industry];
      endpoint += '&publisher_industry=' + industries.join(',');
    }
    
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
    //////console.log("response" + JSON.stringify(response.data));
    return response.data;
  } catch (error) {

    throw error; // re-throw the error so it can be caught by the caller
  }
}


export async function setUserOrg(org_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_USER + '?org_id=' + org_id;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      .put(endpoint, {}, { headers: headers })
      .then(response => {
        ////////////////////////console.log("UPDATED STORY SUCCESSFULLY\n", response.data);
        return response.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function getSavedSearches() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  axios
    .get(process.env.VUE_APP_API_SEARCHES, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      return response.data.saved_searches;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

/**
 * Permanently remove a saved search profile (DELETE user searches API).
 */
export async function deleteSavedSearch(saved_search_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  const endpoint = `${process.env.VUE_APP_API_SEARCH_NOTIFY}?search_id=${encodeURIComponent(saved_search_id)}`;
  const headers = {
    Authorization: `Bearer ${accessToken}`
  };

  return axios
    .delete(endpoint, { headers })
    .then(response => response)
    .catch(error => error);
}

export async function getPanelParticipation(son_id, gov_type, entity_type) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PANEL_PARTICIPATION + '?' + 'son_id=' + son_id + '&' + 'gov_type=' + gov_type + '&' + 'entity_type=' + entity_type;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function getPanelSuppliers(son_id, gov_type, supplier_status, page) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PANEL_SUPPLIERS + '?' + 'son_id=' + son_id + '&' + 'gov_type=' + gov_type + '&' + 'status=' + supplier_status + '&' + 'page=' + page;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function entityAssessment(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PUB_RISK_ASSESSMENT + '?' + 'id=' + id;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function supplierStats(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PUB_SUPPLIER_STATS + '?' + 'id=' + id;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      ////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function buyerStats(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_SUPP_BUYER_STATS + '?' + 'id=' + id;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}


export async function getPanels(gov_type, page, terms) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PANELS;

  var query = Object;
  var urlSettings = [];
  if (gov_type) {
    urlSettings[0] = { field_name: "gov_type", value: gov_type }
  };

  urlSettings[1] = { field_name: "page", value: page };

  if (terms && terms.length > 0) {
    if (gov_type) {
      query = { gov_type: gov_type, page: page, terms: terms };
    }
    else {
      query = { page: page, terms: terms };
    }

    urlSettings[2] = { field_name: "terms", value: JSON.stringify(terms) }
    /* var settingsIndex = urlSettings.length;
    for (var i = 0; i < terms.length; i++){
      urlSettings[settingsIndex] = {field_name: "terms", value: terms[i]};
      settingsIndex++;
    } */
  }
  else {
    if (gov_type) {
      query = { gov_type: gov_type, page: page };
    }
    else {
      query = { page: page };
    }
  }

  silentURLUpdate(urlSettings);

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { query }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function getSonEntityPerformance(son_id, entity_type, entity_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PANEL_ENTITY_PERFORMANCE + '?' + 'son_id=' + son_id + '&' + 'entity_type=' + entity_type + '&' + 'entity_id=' + entity_id;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function getProfileMemberPerformance(profile_id, profile_type, entity_type, entity_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PROFILE_MEMBER_PERFORMANCE + '?' + 'profile_id=' + profile_id + '&' + 'profile_type=' + profile_type + '&' + 'entity_type=' + entity_type + '&' + 'entity_id=' + entity_id;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("SAVED SEARCHES" + JSON.stringify(response.data.saved_searches));
      //////////console.log("data: ", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log(error);
      return error;
    });
}

export async function addCluster(name, entityType, clusterTypeId = null) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_CLUSTER + '?' + 'name=' + name + '&' + 'entity_type=' + entityType;
  if (clusterTypeId !== null) {
    endpoint += '&cluster_type_id=' + clusterTypeId;
  }
  //var data = {cluster_ids: clusterIds, entity_type: entityType, entities: entities}

  return axios
    .post(endpoint, {}, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return error;
    });
}

export async function deleteCluster(cluster_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_CLUSTER + "?id=" + cluster_id;

  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .delete(endpoint, {
        headers: headers
        //data: {id: list_id}
      })
      .then(response => {
        ////////////////////////console.log("CREATED SUCCESSFULLY :", response.data.data);
        return response.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN delete list.. ERROR: ", error );
        return error;
      })
  );
}


export async function updateClusters(clusterIds, entityType, entities) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_CLUSTER_ENTITIES;
  var data = { cluster_ids: clusterIds, entity_type: entityType, entities: entities }

  return axios
    .post(endpoint, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return error;
    });
}

export async function deleteClusterEntities(clusterId, entity_ids) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  var endpoint = process.env.VUE_APP_API_CLUSTER_ENTITIES;
  var data = { cluster_id: clusterId, entity_ids: entity_ids }

  return axios
    .delete(endpoint, { headers: headers, data: data })
    .then(response => {
      ////////////////////////console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return error;
    });
}

export async function getClusters(entityType) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_CLUSTERS + '?' + 'entity_type=' + entityType;
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
}

export async function getCluster(id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_CLUSTER + '?' + 'id=' + id;
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
}

export async function getClusterTypes() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_CLUSTER_TYPES;
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
}

export async function fetchStoryboards() {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_STORYBOARDS
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
  //return true;
}

export async function fetchGovTypes() {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_GOV_TYPES
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
  //return true;
}

export async function deleteStory(storyId) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_STORY + '/' + storyId
  return axios
    .delete(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return error;
    });

}

export async function addStory(storyboardId, data) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_STORY + '/' + storyboardId
  return axios
    .post(endpoint, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return error;
    });

}

export async function addStoryboard(data) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_STORYBOARD
  return axios
    .post(endpoint, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {

      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchStoryboard(id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var endpoint = process.env.VUE_APP_API_STORYBOARD + '/' + id

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {

      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      window.location.replace("/not_found");
      return error;
    });
  //return true;
}

export async function deleteStoryboard(id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_STORYBOARD + '/' + id
  return axios
    .delete(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log(response.data);
      return response.data;
    })
    .catch(error => {
      return error;
    });

}

export async function fetchOpenboard(id) {

  var endpoint = process.env.VUE_APP_API_OPENBOARD + '?public_id=' + id

  return axios
    .get(endpoint)
    .then(response => {

      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN fetchStoryboard.. ERROR: ", error );
      //this.$router.push('notfound')
      window.location.replace("/not_found");
      return error;
    });
  //return true;
}

export async function getPanel(son_id, gov_type) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PANEL + '?son_id=' + son_id + '&gov_type=' + gov_type;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      .get(endpoint, { headers: headers })
      .then(response => {
        ////////////////////////console.log("UPDATED STORY SUCCESSFULLY\n", response.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return null;
      })
  );
  //return true;
}

export async function updateStoryboard(storyboard) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var data = storyboard;

  var endpoint = process.env.VUE_APP_API_STORYBOARD + '/' + storyboard.id;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      .put(endpoint, data, { headers: headers })
      .then(response => {
        ////////////////////////console.log("UPDATED STORY SUCCESSFULLY\n", response.data);
        return response.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function updateStory(story) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var data = story;

  var endpoint = process.env.VUE_APP_API_STORY + '/' + story.id;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .put(endpoint, data, { headers: headers })
      .then(response => {
        ////////////////////////console.log("UPDATED STORY SUCCESSFULLY\n", response.data);
        return response.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function executeOpenSearch(query, page) {
  ////////////////////////console.log("ROUTE: ", process.env.VUE_APP_API_OPEN_SEARCH);
  //var query = VUE_APP_API_LISTS + "/" + list_id;

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_OPEN_SEARCH + "?query=";
  var endpoint =
    endpoint +
    query +
    "&page=" +
    page;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      //////////////////////console.log("FETCHED PROFILE :", response.data.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function getParentCategories() {
  ////////////////////////console.log("in methond@@@@");

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .get(process.env.VUE_APP_API_PARENT_CATEGORIES, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => {
        ////////////////////////console.log("in methond@@@@ :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function getSubCategories(parent_codes) {
  ////////////////////////console.log("in methond@@@@");

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var query = { parent_codes: parent_codes }

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .get(process.env.VUE_APP_API_SUB_CATEGORIES, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        params: {
          query: query
          //page: page,
        }
      })
      .then(response => {
        ////////////////////////console.log("API MGR SUBCATS :", response.data);
        return response.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function getUserLists() {
  ////////////////////////console.log("in methond@@@@");

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .get(process.env.VUE_APP_API_LISTS, {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
      .then(response => {
        ////////////////////////console.log("in methond@@@@ :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export function getListItemsQuery(list) {
  ////////////////////////console.log("in methond@@@@");
  //var endpoint = process.env.VUE_APP_API_LISTS + "/" + list_id;
  var query = list.query;

  return query;
}

export async function searchByEntityId(id, entity_type) {
  var params = {};

  var results = [];

  if (entity_type === "publisher") {
    params["query"] = { publisher_id: [id] };
  } else {
    params["query"] = { supplier_id: [id] };
  }

  results = await executeSearch(params);
  return results;
  /* executeSearch(params).then(data => {
    return data
    }); */
}

export async function groupBySearch(query, page, field, sort_by) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_GRP_BY_SEARCH, {
      query: query,
      page: page,
      field: field,
      sort_by: sort_by
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function executePlainTextSearch(query) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .get(process.env.VUE_APP_API_AI_QUERY, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: {
        query: query,
      }
    })
    .then(response => {
      //////console.log("RESULTS :", response);
      return response;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function deleteAIQuery(aiquery_id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  ////////////////////////console.log("in methond@@@@");
  var endpoint = process.env.VUE_APP_API_AI_QUERY + "?id=" + aiquery_id;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .delete(endpoint, {
        headers: headers
        //data: {id: list_id}
      })
      .then(response => {
        ////////////////////////console.log("CREATED SUCCESSFULLY :", response.data.data);
        return response;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN delete list.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function fetchSearchQuery(plainText, timestamp, query_id, querystring, thread_id, analyse) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var query = null;

  if (query_id) {
    query = process.env.VUE_APP_API_SEARCH_QUERY + '?query=' + plainText + '&query_id=' + query_id + '&thread_id=' + thread_id + '&querystring=' + querystring + '&timestamp=' + timestamp + '&analyse=' + analyse;
  }
  else {
    query = process.env.VUE_APP_API_SEARCH_QUERY + '?query=' + plainText + '&querystring=' + querystring + '&timestamp=' + timestamp;
  }


  return axios
    .get(query, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED PROFILE :", response.data.aggregations);
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}
// To be deprecated with getLangGraphResponse()
export async function fetchAIQueries() {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .get(process.env.VUE_APP_API_GET_AI_QUERIES, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED PROFILE :", response.data.aggregations);
      return response;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}


export async function executeSearch(query, page) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_ADV_SEARCH, {
      query: query,
      page: page
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function searchAnalyzer(query) {
  ////////////////////////console.log("SEARCH ANALYZER: " + JSON.stringify(query));
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_ANALYZER, {
      query: query,
      page: 1
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function histogramSearch(query, page) {
  ////////////////////////console.log("HISTOGRAM: " + JSON.stringify(query));
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_GRP_BY_HISTOGRAM, {
      query: query,
      page: page
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function graphSearch(query, page) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_GRP_BY_GRAPH, {
      query: query,
      page: page
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function entityAnalysis(page, query, entity_type, after) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_ANALYZER_ENTITIES, {
      query: query,
      page: page,
      entity_type: entity_type,
      after: after
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function entitySearch(query, page) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .post(process.env.VUE_APP_API_GRP_BY_ENTITY, {
      query: query,
      page: page
    }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("RESULTS :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function getStats() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .get(process.env.VUE_APP_API_STATS, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED PROFILE :", response.data.aggregations);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function fetchBuyerIndustries() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PUBLISHER_INDUSTRY_LIST
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function fetchAllContacts(term) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PUB_CONTACTS + '?term=' + term;
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function fetchProcurementMethods() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_GET_PROCUREMENT_METHODS
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function fetchCategoryList() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_GET_CATEGORY_LIST
  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
}

export async function removeFromList(tender_id, lists) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var data = { "tender_id": parseInt(tender_id), "lists": lists }

  var endpoint =
    process.env.VUE_APP_API_BOOKMARK;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .post(endpoint, data, { headers })
      .then(response => {
        ////////////////////////console.log("ADDED SUCCESSFULLY :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function addToList(tender_id, lists) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  var data = Object;

  ////////console.log("tender_id: ", tender_id);

  if (Array.isArray(tender_id)) {
    //////////console.log("tender_id: ", tender_id);
    data = { "tender_id": tender_id, "lists": lists }
  }
  else {
    data = { "tender_id": parseInt(tender_id), "lists": lists }
  }

  //var data = {"tender_id": tender_id, "lists": lists}

  var endpoint =
    process.env.VUE_APP_API_BOOKMARK;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .post(endpoint, data, { headers })
      .then(response => {
        ////////////////////////console.log("ADDED SUCCESSFULLY :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}


export async function createNewList(list_name) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("createNewList");
  var endpoint = process.env.VUE_APP_API_LIST + "?name=" + list_name;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .post(endpoint, null, { headers })
      .then(response => {
        ////////////////////////console.log("CREATED SUCCESSFULLY :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function updateNewsPage(entity_id, url) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  ////////////////////////console.log("in methond@@@@");
  var endpoint =
    process.env.VUE_APP_API_PUBLISHERS +
    "/" +
    entity_id +
    "/news_source" +
    "?news=" +
    url;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .post(endpoint, null, { headers })
      .then(response => {
        ////////////////////////console.log("CREATED SUCCESSFULLY :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function deleteList(list_id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  ////////////////////////console.log("in methond@@@@");
  var endpoint = process.env.VUE_APP_API_LIST + "?id=" + list_id;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return (
    axios
      //.get("http://128.199.248.51/api/1/tenders")
      .delete(endpoint, {
        headers: headers
        //data: {id: list_id}
      })
      .then(response => {
        ////////////////////////console.log("CREATED SUCCESSFULLY :", response.data.data);
        return response.data.data;
      })
      .catch(error => {
        ////////////////////////console.log("ERROR IN delete list.. ERROR: ", error );
        return error;
      })
  );
  //return true;
}

export async function autocomplete(terms, field) {
  ////////////////////////console.log("in methond@@@@");

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var query =
    process.env.VUE_APP_API_AUTOCOMPLETE +
    "?" +
    "terms=" +
    encodeURIComponent(terms) +
    "&field=" +
    field;

  return axios
    .get(query, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      ////////////////////////console.log("AUTOCOMPLETE :", response.data.data);
      //response.data.data.unshift({ key: terms });
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchNews(entity) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  var params = { entity: entity, cc: "au", category: "business" };

  return axios
    .get(process.env.VUE_APP_API_NEWS, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      ////////////////////////console.log("FETCHED NEWS :", response.data.data);
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchProfile(entity_id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");
  var period = 1040; // 20 years
  var params = { entity_id: entity_id, period: period };

  return axios
    .get(process.env.VUE_APP_API_PROFILE, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      ////////////////////////console.log("PROFILE: ", JSON.stringify(response.data.data.profile));
      return response.data.data.profile;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchProfileByCounterparty(entity_id, counterparty_id, counterparty_type) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");
  var period = 1040; // 20 years
  var params = {
    entity_id: entity_id,
    period: period,
    counterparty_type: counterparty_type + "_id",
    counterparty_id: counterparty_id
  };

  return axios
    .get(process.env.VUE_APP_API_PROFILE, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      ////////////////////////console.log("PROFILE: ", JSON.stringify(response.data.data.profile));
      return response.data.data.profile;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchSupplier(entity_id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");
  var period = 1040; // 20 yurs
  var params = { entity_id: entity_id, period: period };

  return axios
    .get(process.env.VUE_APP_API_SUPPLIER, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      ////////////////////////console.log("SUPPLIER: ", JSON.stringify(response.data.data.profile));
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchSupplierByCounterparty(entity_id, counterparty_id, counterparty_type) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");
  var period = 1040; // 20 yurs
  var params = {
    entity_id: entity_id,
    period: period,
    counterparty_type: counterparty_type + "_id",
    counterparty_id: counterparty_id
  };

  return axios
    .get(process.env.VUE_APP_API_SUPPLIER, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      ////////////////////////console.log("SUPPLIER: ", JSON.stringify(response.data.data.profile));
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchCategory(category_id) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");
  var period = 1040; // 20 yurs
  var params = { category_id: category_id, period: period };

  return axios
    .get(process.env.VUE_APP_API_CATEGORY, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: params
    })
    .then(response => {
      ////////////////////////console.log("SUPPLIER: ", JSON.stringify(response.data.data.profile));
      return response.data.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchPublishers(page_num, query) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  //var query = { period: 156, term: terms, government: government };

  if (query && query["supplier_id"]) {
    query.supplier_id = parseInt(query.supplier_id)
  }

  return axios
    .get(process.env.VUE_APP_API_PUBLISHERS, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { query: query, page: page_num }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED PUBLISHERS :", response.data.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchPublisherDirectory(page_num, query) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  // Build filters object for the new API format
  const filters = {};
  
  // Map "term" to "name" (PublisherSearch uses "term")
  if (query && query["term"]) {
    filters.name = query["term"];
  }
  
  // Add gov_type filter if present (support both "gov_type" and "government" for backward compatibility)
  if (query && (query["gov_type"] || query["government"])) {
    const govTypes = query["gov_type"] || query["government"];
    filters.gov_type = Array.isArray(govTypes) 
      ? govTypes 
      : [govTypes];
  }
  
  // Add cofog_code filter if present
  if (query && query["cofog_code"]) {
    filters.cofog_code = Array.isArray(query["cofog_code"]) 
      ? query["cofog_code"] 
      : [query["cofog_code"]];
  }
  
  // Add search flags (default to true if not specified)
  if (query && query.hasOwnProperty("include_description")) {
    filters.include_description = query["include_description"] === 'true' || query["include_description"] === true;
  } else {
    filters.include_description = true; // Default to true
  }

  return axios
    .get(process.env.VUE_APP_API_PUBLISHER_DIRECTORY, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { 
        query: JSON.stringify(filters),
        page: page_num,
        page_size: 50
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      //console.error("Error fetching publisher directory:", error);
      throw error;
    });
}

export async function fetchCofogClassifications() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .get(process.env.VUE_APP_API_COFOG_CLASSIFICATIONS, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      //console.error("Error fetching COFOG classifications:", error);
      throw error;
    });
}


export async function fetchCategories(page_num, query) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  if (query && query["supplier_id"]) {
    query.supplier_id = parseInt(query.supplier_id)
  }

  //var query = { period: 156, term: terms };

  return axios
    .get(process.env.VUE_APP_API_CATEGORIES, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { query: query, page: page_num }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED PUBLISHERS :", response.data.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN GETUSERLISTS.. ERROR: ", error );
      return error;
    });
  //return true;
}

export async function fetchSuppliers(page_num, query) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  if (query && query["publisher_id"]) {
    query.publisher_id = parseInt(query.publisher_id)
  }

  if (query && query["category_id"] && Array.isArray(query["category_id"])) {
    query.category_id = parseInt(query["category_id"][0])
  }

  let url = process.env.VUE_APP_API_SUPPLIERS;
  //process.env.VUE_APP_API_SUPPLIERS

  return axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { query: query, page: page_num }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED suppliers :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN FETCH SUPPLIERS.. ERROR: ", error);
      return error;
    });
  //return true;
}

export async function fetchSupplierDirectory(page_num, query) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  // Build filters object for the new API format
  const filters = {};
  
  // Map "term" to "name" (SupplierSearch uses "term")
  if (query && query["term"]) {
    filters.name = query["term"];
  }
  
  // Add industry_id filter if present
  if (query && query["industry_id"]) {
    filters.industry_id = Array.isArray(query["industry_id"]) 
      ? query["industry_id"] 
      : [query["industry_id"]];
  }
  
  // Add search flags (default to true if not specified)
  if (query && query.hasOwnProperty("include_tags")) {
    filters.include_tags = query["include_tags"] === 'true' || query["include_tags"] === true;
  } else {
    filters.include_tags = true; // Default to true
  }
  
  if (query && query.hasOwnProperty("include_description")) {
    filters.include_description = query["include_description"] === 'true' || query["include_description"] === true;
  } else {
    filters.include_description = true; // Default to true
  }

  let url = process.env.VUE_APP_API_SUPPLIER_DIRECTORY;

  return axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { 
        query: JSON.stringify(filters), 
        page: page_num,
        page_size: 50
      }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED suppliers :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN FETCH SUPPLIERS.. ERROR: ", error);
      return error;
    });
  //return true;
}

export async function fetchContacts(publisher_id, page) {

  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  ////////////////////////console.log("in methond@@@@");

  //var query = { publisher_id: publisher_id };

  let url = process.env.VUE_APP_API_PUB_CONTACTS;
  //process.env.VUE_APP_API_SUPPLIERS

  return axios
    .get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      params: { publisher_id: publisher_id, page: page }
    })
    .then(response => {
      ////////////////////////console.log("FETCHED suppliers :", response.data);
      return response.data;
    })
    .catch(error => {
      ////////////////////////console.log("ERROR IN FETCH SUPPLIERS.. ERROR: ", error);
      return error;
    });
  //return true;
}

export async function addPipeline(name) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_PIPELINE + '?name=' + name;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return axios
    .post(endpoint, null, { headers })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      ////console.error("ERROR adding pipeline:", error);
      return error;
    });
}

export async function getPipelines() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();
  // //console.log("Bearer token:", accessToken);

  var endpoint = process.env.VUE_APP_API_PIPELINES;
  ////console.log("Pipeline API endpoint:", process.env.VUE_APP_API_PIPELINES);
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/x-www-form-urlencoded"
  };

  return axios
    .get(endpoint, { headers })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      ////console.error("ERROR fetching pipelines:", error);
      return error;
    });
}

export async function updatePipelines(tender_id, pipelines) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  // Ensure tender_id is a valid integer
  const parsedTenderId = parseInt(tender_id);
  if (isNaN(parsedTenderId) || parsedTenderId <= 0) {
    return Promise.reject(new Error(`Invalid tender_id: ${tender_id}`));
  }

  var data = {
    tender_id: parsedTenderId,
    lists: pipelines.map(id => parseInt(id)).filter(id => !isNaN(id) && id > 0)
  };

  var endpoint = process.env.VUE_APP_API_UPDATE_PIPELINES;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };

  return axios
    .post(endpoint, data, { headers })
    .then(response => response.data)
    .catch(error => {
      // Log more details about the error
      if (error.response) {
        console.error('Error updating pipeline:', {
          status: error.response.status,
          data: error.response.data,
          tender_id: parsedTenderId,
          pipelines: data.lists
        });
      } else {
        console.error('Error updating pipeline:', error.message);
      }
      return Promise.reject(error);
    });
}

// Cluster Management API Functions

export async function getAllUsersWithStats(emailDomain = null, entityType = null) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    let endpoint = process.env.VUE_APP_API_CLUSTER_MANAGEMENT + '?include_stats=true';

    if (emailDomain) {
      endpoint += `&email_domain=${encodeURIComponent(emailDomain)}`;
    }

    if (entityType) {
      endpoint += `&entity_type=${encodeURIComponent(entityType)}`;
    }

    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserClusters(userId, entityType = null) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    let endpoint = process.env.VUE_APP_API_CLUSTER_COPY + `?user_id=${encodeURIComponent(userId)}`;

    if (entityType) {
      endpoint += `&entity_type=${encodeURIComponent(entityType)}`;
    }

    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function validateClusterCopy(copyData) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_CLUSTER_MANAGEMENT;

    const response = await axios.post(endpoint, copyData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function copyClusters(copyData) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_CLUSTER_COPY;

    const response = await axios.post(endpoint, copyData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

// User Domain API Functions

export async function getUserDomains() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_USER_DOMAINS;

    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserDomainStats() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpoint = process.env.VUE_APP_API_USER_DOMAIN_STATS;

    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getUserProfile() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_USER_PROFILE;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };

  return axios
    .get(endpoint, { headers })
    .then(response => response.data)
    .catch(error => {
      // error("ERROR updating pipeline selection:", error);
      return Promise.reject(error);
    });
}

export async function updateUserProfile(data) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  var endpoint = process.env.VUE_APP_API_USER_PROFILE;
  var headers = {
    Authorization: `Bearer ${accessToken}`,
    "Content-Type": "application/json"
  };

  return axios
    .post(endpoint, data, { headers })
    .then(response => response.data)
    .catch(error => {
      // error("ERROR updating pipeline selection:", error);
      return Promise.reject(error);
    });
}

export async function updateEmailPreferences(send_emails, token = null) {
  // Build endpoint - use environment variable if available, otherwise construct from serverUrl
  // Note: API blueprint is registered with /api/1 prefix
  var endpoint = process.env.VUE_APP_API_EMAIL_PREFERENCES || `${serverUrl}/api/1/user/email_preferences`;
  
  // Build query parameters
  var params = new URLSearchParams();
  params.append('send_emails', send_emails);
  if (token) {
    params.append('token', token);
  }
  
  var headers = {
    "Content-Type": "application/json"
  };
  
  // Only add Authorization header if no token is provided (authenticated user)
  if (!token) {
    const instance = getInstance();
    const accessToken = await instance.getTokenSilently();
    headers.Authorization = `Bearer ${accessToken}`;
  }
  
  // Make PUT request with query parameters
  const url = `${endpoint}?${params.toString()}`;
  
  return axios
    .put(url, {}, { headers })
    .then(response => response.data)
    .catch(error => {
      return Promise.reject(error);
    });
}

// Profile Intelligence API functions
export async function fetchBuyerIntelligence(publisher_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_BUYER_INTELLIGENCE || `${serverUrl}/api/1/buyer/:publisher_id/intelligence`;
    const endpoint = endpointTemplate.replace(':publisher_id', publisher_id);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error fetching buyer intelligence:", errorDetails);
    throw error;
  }
}

export async function fetchBuyerCompetitors(publisher_id, min_spend = 0, status = null) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const params = { min_spend };
    if (status) params.status = status;
    const endpointTemplate = process.env.VUE_APP_API_BUYER_COMPETITORS || `${serverUrl}/api/1/buyer/:publisher_id/competitors`;
    const endpoint = endpointTemplate.replace(':publisher_id', publisher_id);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      params: params
    });
    return response.data;
  } catch (error) {
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error fetching buyer competitors:", errorDetails);
    throw error;
  }
}

export async function fetchBuyerOpportunities(publisher_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_BUYER_OPPORTUNITIES || `${serverUrl}/api/1/buyer/:publisher_id/opportunities`;
    const endpoint = endpointTemplate.replace(':publisher_id', publisher_id);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error fetching buyer opportunities:", errorDetails);
    throw error;
  }
}

export async function fetchBuyerProfile(publisher_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_BUYER_PROFILE || `${serverUrl}/api/1/buyer/:publisher_id/profile`;
    const endpoint = endpointTemplate.replace(':publisher_id', publisher_id);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    return response.data;
  } catch (error) {
    ////console.error("Error fetching buyer profile:", error);
    throw error;
  }
}

// Supplier Intelligence API functions
export async function fetchSupplierIntelligence(supplier_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_INTELLIGENCE || `${serverUrl}/api/1/supplier/:supplier_id/intelligence`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier intelligence from:", endpoint);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    //console.log("Supplier intelligence response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier intelligence:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierSharedBuyers(supplier_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_SHARED_BUYERS || `${serverUrl}/api/1/supplier/:supplier_id/shared-buyers`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier shared buyers from:", endpoint);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    //console.log("Supplier shared buyers response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier shared buyers:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierMarketOverlap(supplier_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_MARKET_OVERLAP || `${serverUrl}/api/1/supplier/:supplier_id/market-overlap`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier market overlap from:", endpoint);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    //console.log("Supplier market overlap response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier market overlap:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierCompetitiveComparison(supplier_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_COMPETITIVE_COMPARISON || `${serverUrl}/api/1/supplier/:supplier_id/competitive-comparison`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier competitive comparison from:", endpoint);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    //console.log("Supplier competitive comparison response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier competitive comparison:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierSharedBuyersWithRisk(supplier_id, limit = 20, min_risk = null) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const params = { limit };
    if (min_risk) params.min_risk = min_risk;
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_SHARED_BUYERS_RISK || `${serverUrl}/api/1/supplier/:supplier_id/shared-buyers-risk`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier shared buyers with risk from:", endpoint, "with params:", params);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      params: params
    });
    //console.log("Supplier shared buyers with risk response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier shared buyers with risk:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierTargetingOpportunities(supplier_id, limit = 15, min_spend = 0) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const params = { limit, min_spend };
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_TARGETING_OPPORTUNITIES || `${serverUrl}/api/1/supplier/:supplier_id/targeting-opportunities`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier targeting opportunities from:", endpoint, "with params:", params);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      params: params
    });
    //console.log("Supplier targeting opportunities response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier targeting opportunities:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierAtRiskCustomers(supplier_id, limit = 10) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const params = { limit };
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_AT_RISK_CUSTOMERS || `${serverUrl}/api/1/supplier/:supplier_id/at-risk-customers`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier at-risk customers from:", endpoint, "with params:", params);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      },
      params: params
    });
    //console.log("Supplier at-risk customers response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier at-risk customers:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function fetchSupplierCompetitiveInsights(supplier_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  try {
    const endpointTemplate = process.env.VUE_APP_API_SUPPLIER_COMPETITIVE_INSIGHTS || `${serverUrl}/api/1/supplier/:supplier_id/competitive-insights`;
    const endpoint = endpointTemplate.replace(':supplier_id', supplier_id);
    //console.log("Fetching supplier competitive insights from:", endpoint);
    const response = await axios.get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json"
      }
    });
    //console.log("Supplier competitive insights response:", response.data);
    return response.data;
  } catch (error) {
    //console.error("Error fetching supplier competitive insights:", error);
    const errorDetails = error.response && error.response.data ? error.response.data : error.message;
    //console.error("Error details:", errorDetails);
    throw error;
  }
}

export async function submitTraceyQuery(plainText, thread_id, options = {}) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const base = process.env.VUE_APP_API_TRACEY_QUERY_STREAM;
  const params = new URLSearchParams({ query: plainText || '', thread_id: thread_id || '' });
  // "sprint" | "ultra" -- which Tracey agent should answer. Backend defaults
  // to ultra when omitted, so this is safe to leave unset for now.
  if (options.version) params.set('version', options.version);
  const url = `${base}?${params.toString()}`;

  const fetchOptions = { headers: { Authorization: `Bearer ${accessToken}` } };
  if (options.signal) fetchOptions.signal = options.signal;
  return await fetch(url, fetchOptions);
}

/**
 * Read the signed-in user's current Tracey credit balance for one agent.
 *
 * Sprint and Ultra each have their own wallet, so `version` ("sprint" |
 * "ultra") picks which one comes back; defaults to ultra server-side if
 * omitted. There is no dedicated env var for this endpoint, so the URL is
 * derived from the query-stream base (…/api/1/tracey_query_stream ->
 * …/api/1/tracey/usage), keeping it pinned to the same host/base as the rest
 * of the Tracey API. Returns the balance snapshot object, or null on any
 * error (non-fatal: the UI just hides the chip).
 */
export async function fetchTraceyUsage(version) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const streamBase = process.env.VUE_APP_API_TRACEY_QUERY_STREAM || '';
  const url = streamBase.includes('/tracey_query_stream')
    ? streamBase.replace('/tracey_query_stream', '/tracey/usage')
    : streamBase.replace(/\/[^/]*$/, '/tracey/usage');

  const response = await axios.get(url, {
    params: version ? { version } : {},
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return response.data;
}

/**
 * Per-query Tracey usage history (query text, tokens, cost) for the signed-in
 * user. URL is derived from the query-stream base, same as fetchTraceyUsage.
 * Returns an array of usage items (newest first).
 */
export async function fetchTraceyUsageHistory(limit = 100) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const streamBase = process.env.VUE_APP_API_TRACEY_QUERY_STREAM || '';
  const url = streamBase.includes('/tracey_query_stream')
    ? streamBase.replace('/tracey_query_stream', '/tracey/usage/history')
    : streamBase.replace(/\/[^/]*$/, '/tracey/usage/history');

  const response = await axios.get(url, {
    params: { limit },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return (response.data && response.data.items) || [];
}

/**
 * Raw credit ledger entries for the signed-in user, newest first: grants,
 * per-query debits, resets, and Stripe top-ups. Unlike
 * fetchTraceyUsageHistory (debits only, grouped by conversation thread),
 * this is every wallet movement -- including events with no thread/query.
 */
export async function fetchTraceyTransactions(limit = 100) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const streamBase = process.env.VUE_APP_API_TRACEY_QUERY_STREAM || '';
  const url = streamBase.includes('/tracey_query_stream')
    ? streamBase.replace('/tracey_query_stream', '/tracey/transactions')
    : streamBase.replace(/\/[^/]*$/, '/tracey/transactions');

  const response = await axios.get(url, {
    params: { limit },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return (response.data && response.data.items) || [];
}

/**
 * Daily credit usage for the last N days, split by agent (Sprint/Ultra).
 * Days with no usage come back zero-filled. Backs the /usage page chart.
 */
export async function fetchTraceyUsageDaily(days = 30) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const streamBase = process.env.VUE_APP_API_TRACEY_QUERY_STREAM || '';
  const url = streamBase.includes('/tracey_query_stream')
    ? streamBase.replace('/tracey_query_stream', '/tracey/usage/daily')
    : streamBase.replace(/\/[^/]*$/, '/tracey/usage/daily');

  const response = await axios.get(url, {
    params: { days },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return (response.data && response.data.days) || [];
}

/**
 * Purchasable Tracey Ultra top-up tiers ({ credits, price }[]), server-driven
 * so the frontend never hardcodes pricing.
 */
export async function fetchTraceyTopupTiers(agentVersion) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const streamBase = process.env.VUE_APP_API_TRACEY_QUERY_STREAM || '';
  const url = streamBase.includes('/tracey_query_stream')
    ? streamBase.replace('/tracey_query_stream', '/tracey/topup')
    : streamBase.replace(/\/[^/]*$/, '/tracey/topup');

  const response = await axios.get(url, {
    params: { version: agentVersion },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return (response.data && response.data.tiers) || [];
}

/**
 * Start a Stripe Checkout Session for one top-up tier's worth of Tracey
 * credits (Sprint or Ultra). Returns { checkout_url } -- redirect the
 * browser there (`window.location.href = checkout_url`) to complete
 * payment on Stripe's hosted page. Credits are granted only after Stripe
 * confirms the payment via a webhook, not by this call.
 */
export async function createTraceyTopupCheckout(agentVersion, credits) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const streamBase = process.env.VUE_APP_API_TRACEY_QUERY_STREAM || '';
  const url = streamBase.includes('/tracey_query_stream')
    ? streamBase.replace('/tracey_query_stream', '/tracey/topup')
    : streamBase.replace(/\/[^/]*$/, '/tracey/topup');

  const response = await axios.post(url, { credits }, {
    params: { version: agentVersion },
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  return response.data;
}

/**
 * Download a PDF that Tracey generated during a chat.
 *
 * The endpoint is auth-protected, and a plain <a href> navigation would not
 * carry the bearer token, so fetch it with the token and hand the browser a
 * blob instead.
 */
export async function downloadTraceyFile(downloadUrl, filename) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const response = await fetch(downloadUrl, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename || 'report.pdf';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(objectUrl);
}

export async function submitTraceySearchQuery(plainText) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const query = process.env.VUE_APP_API_TRACEY_SEARCH_QUERY +
    `?query=${plainText}`;

  return await fetch(query, { headers: { Authorization: `Bearer ${accessToken}` } });
}

export async function fetchUserThreadsAPI() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  return axios
    .get(process.env.VUE_APP_API_TRACEY_THREADS, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      const data = response.data;
      return Array.isArray(data) ? data : (data?.threads ?? []);
    })
    .catch(error => {
      console.error('fetchUserThreadsAPI error:', error);
      throw error;
    });
}

export async function fetchMessagesForThreadAPI(thread_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const query = process.env.VUE_APP_API_MESSAGES_FOR_THREAD +
    `?thread_id=${thread_id}`;

  return axios
    .get(query, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      const data = response.data;
      return Array.isArray(data) ? data : (data?.messages ?? []);
    })
    .catch(error => {
      console.error('fetchMessagesForThreadAPI error:', error);
      throw error;
    });
}

export async function deleteTraceyThread(thread_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const query = process.env.VUE_APP_API_TRACEY_THREAD +
    `/${thread_id}`;

  return axios
    .delete(query, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });

}

export async function stopTraceyThread(thread_id) {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const url = `${process.env.VUE_APP_API_TRACEY_THREAD}/${thread_id}`;

  return axios
    .post(url, { action: 'stop' }, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => response.data)
    .catch(error => {
      console.error('stopTraceyThread error:', error);
      throw error;
    });
}

export async function fetchDailyDigest() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const endpoint = process.env.VUE_APP_API_DAILY_DIGEST;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      //console.error('Error fetching daily digest:', error);
      throw error;
    });
}

export async function fetchPromptLibrary() {
  const instance = getInstance();
  const accessToken = await instance.getTokenSilently();

  const endpoint = process.env.VUE_APP_API_PROMPT_LIBRARY;

  return axios
    .get(endpoint, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      //console.error('Error fetching digest dashboard:', error);
      throw error;
    });
}
